module.exports = __webpack_public_path__ + "static/media/cuttingRope.93f7f5e7.png";